import React from 'react';

import CardRules from '@components/card-rules/CardRules';

const CardRulesPage = () => (
    <div className="sgw-layout seven-four-container">
        <div className="sgw-layout-item seven">
            <div className="sgw-layout-item">
                <CardRules />
            </div>
        </div>
    </div>
);

export default CardRulesPage;
